import { render } from "./CardComponent.vue?vue&type=template&id=f58c5e10&scoped=true"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"

import "./CardComponent.vue?vue&type=style&index=0&id=f58c5e10&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f58c5e10"]])

export default __exports__